import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  formType: null,
  relatiedId: null,
  callFormFrom: "",
  personReciveCartableToast: {},
};

const setFormType = (state, action) => {
  state.formType = action.payload;
};
const setRelatiedId = (state, action) => {
  state.relatiedId = action.payload;
};
const setCallFormFrom = (state, action) => {
  state.callFormFrom = action.payload;
};
const setPersonReciveCartableToast = (state, action) => {
  state.personReciveCartableToast = action.payload;
};
const clearFormType = (state) => {
  state.formType = null;
};
const clearRelatiedId = (state) => {
  state.relatiedId = null;
};
const clearCallFormFrom = (state) => {
  state.callFormFrom = "";
};
const PersonCartableSlice = createSlice({
  name: "PersonCartable",
  initialState,
  reducers: {
    setFormType,
    clearFormType,
    setRelatiedId,
    clearRelatiedId,
    setCallFormFrom,
    clearCallFormFrom,
    setPersonReciveCartableToast,
  },
});
export const {
  setFormType: setFormTypeR,
  clearFormType: clearFormTypeR,
  setRelatiedId: setRelatiedIdR,
  clearRelatiedId: clearRelatiedIdR,
  setCallFormFrom: setCallFormFromR,
  clearCallFormFrom: clearCallFormFromR,
  setPersonReciveCartableToast: setPersonReciveCartableToastR,
} = PersonCartableSlice.actions;

export default PersonCartableSlice.reducer;
